module.exports = __webpack_public_path__ + "static/media/mazaZolePlayed_10010_10000.bec75f18.png";